module.exports = __webpack_public_path__ + "static/media/bigCall.a744d8bf.svg";